import type { InvoiceLabels } from "./types";

export const trInvoiceLabels: InvoiceLabels = {
  page: {
    title: "Faturalar",
    subtitle: "Tüm fatura ve tahsilat hareketleri",
    breadcrumb: "Para Makinesi · Faturalar",
    backToCashier: "Kasaya Dön",
    branchLabel: "Şube",
    exportAction: "Dışa Aktar",
    createAction: "Manuel Fatura Kes",
  },
  summary: {
    title: "Özet",
    totalCount: "Toplam Fatura",
    draft: "Taslak",
    issued: "Kesildi",
    paid: "Ödendi",
    failed: "Başarısız",
    grossMinor: "Brüt",
    taxMinor: "KDV",
    netMinor: "Net",
    paidMinor: "Tahsil Edilen",
    balanceMinor: "Açık Bakiye",
  },
  filters: {
    search: "Fatura no, müşteri, VKN/TCKN ara…",
    status: "Durum",
    type: "Tür",
    dateRange: "Tarih",
    customer: "Müşteri",
    apply: "Uygula",
    clear: "Temizle",
    savedViews: "Kayıtlı görünümler",
    today: "Bugün",
    last7: "Son 7 Gün",
    last30: "Son 30 Gün",
    thisMonth: "Bu Ay",
    custom: "Özel",
    from: "Başlangıç",
    to: "Bitiş",
  },
  tabs: {
    all: "Tümü",
    overdue: "Vadesi Geçmiş",
  },
  type: {
    e_arsiv: "e-Arşiv",
    e_fatura: "e-Fatura",
  },
  status: {
    draft: "Taslak",
    issued: "Kesildi",
    sent: "Gönderildi",
    paid: "Ödendi",
    voided: "İptal",
    failed: "Başarısız",
  },
  delivery: {
    not_sent: "Gönderilmedi",
    sent_email: "E-posta",
    sent_whatsapp: "WhatsApp",
    delivered: "İletildi",
    opened: "Açıldı",
  },
  columns: {
    invoiceNumber: "Fatura No",
    issuedAt: "Tarih",
    customer: "Müşteri",
    type: "Tür",
    total: "Toplam",
    paid: "Tahsil",
    balance: "Bakiye",
    status: "Durum",
    delivery: "İletim",
    actions: "İşlemler",
  },
  row: {
    draftBadge: "Taslak",
    overdue: "Vadesi Geçmiş",
    dueIn: "kaldı",
    failedRetry: "Yeniden Dene",
    viewDetail: "Detayı Gör",
    pdf: "PDF İndir",
    xml: "UBL-XML İndir",
    copyShareLink: "Ödeme Linkini Kopyala",
    sendEmail: "E-posta ile Gönder",
    sendWhatsapp: "WhatsApp ile Gönder",
    issue: "Faturayı Kes",
    void: "İptal Et",
    selectRow: "Satırı seç",
    selectAll: "Tümünü seç",
    rowActions: "Satır işlemleri",
  },
  detail: {
    title: "Fatura Detayı",
    lines: "Kalemler",
    payments: "Ödemeler",
    notes: "Notlar",
    issuedBy: "Kesildiği zaman",
    gibCode: "GİB Kodu",
    integrator: "Entegratör",
    integratorError: "Entegratör Hatası",
    linkedOrder: "Bağlı Sipariş",
    linkedBooking: "Bağlı Randevu",
    copy: "Kopyala",
    retryIssue: "Yeniden Dene",
    download: "İndir",
    customer: "Müşteri",
    summary: "Özet",
    subtotal: "Ara Toplam",
    discount: "İndirim",
    tax: "KDV",
    total: "Toplam",
    paid: "Tahsil Edilen",
    balance: "Bakiye",
    audit: "Denetim",
    createdAt: "Oluşturuldu",
    updatedAt: "Güncellendi",
    close: "Kapat",
    print: "Yazdır",
  },
  voidDialog: {
    title: "Faturayı İptal Et",
    description:
      "Bu işlem geri alınamaz. Düzeltme faturası kesmeniz gerekebilir.",
    reason: "İptal Sebebi",
    cancel: "Vazgeç",
    confirm: "İptal Et",
    reasons: {
      wrong_customer: "Yanlış müşteri",
      wrong_amount: "Yanlış tutar",
      wrong_service: "Yanlış hizmet",
      customer_request: "Müşteri talebi",
      other: "Diğer",
    },
    explanationLabel: "Açıklama",
    explanationPlaceholder: "Lütfen en az 10 karakter açıklama girin",
  },
  sendDialog: {
    title: "Faturayı Gönder",
    email: "E-posta",
    whatsapp: "WhatsApp",
    target: "Alıcı",
    emailPlaceholder: "ornek@eposta.com",
    phonePlaceholder: "+90 555 000 0000",
    cancel: "Vazgeç",
    send: "Gönder",
    messageLabel: "Not (opsiyonel)",
    messagePlaceholder: "Müşteriye eklenecek kısa not…",
  },
  bulk: {
    selected: "fatura seçildi",
    sendAll: "Topluca Gönder",
    downloadZip: "PDF İndir (Zip)",
    voidAll: "Topluca İptal",
    clear: "Seçimi Temizle",
  },
  empty: {
    title: "Henüz fatura yok",
    description:
      "Kasada işlem tamamlandığında faturalar otomatik olarak burada listelenir.",
    createAction: "Manuel Fatura Kes",
  },
  errors: {
    loadFailed: "Faturalar yüklenemedi",
    issueFailed: "Fatura kesilemedi",
    sendFailed: "Fatura gönderilemedi",
    voidFailed: "Fatura iptal edilemedi",
    downloadFailed: "Fatura indirilemedi",
    retry: "Tekrar Dene",
    integratorOffline: "GİB entegratörü çevrimdışı",
  },
  toasts: {
    issued: "Fatura başarıyla kesildi",
    sent: "Fatura gönderildi",
    voided: "Fatura iptal edildi",
    downloaded: "Fatura indirildi",
    linkCopied: "Ödeme linki kopyalandı",
  },
  pagination: {
    pageOf: "Sayfa",
    records: "kayıt",
    prev: "Önceki",
    next: "Sonraki",
  },
};

export const enInvoiceLabels: InvoiceLabels = {
  page: {
    title: "Invoices",
    subtitle: "All invoice and collection activity",
    breadcrumb: "Cashier · Invoices",
    backToCashier: "Back to Cashier",
    branchLabel: "Branch",
    exportAction: "Export",
    createAction: "Create Invoice",
  },
  summary: {
    title: "Summary",
    totalCount: "Total Invoices",
    draft: "Draft",
    issued: "Issued",
    paid: "Paid",
    failed: "Failed",
    grossMinor: "Gross",
    taxMinor: "Tax",
    netMinor: "Net",
    paidMinor: "Collected",
    balanceMinor: "Outstanding",
  },
  filters: {
    search: "Search invoice no, customer, tax id…",
    status: "Status",
    type: "Type",
    dateRange: "Date",
    customer: "Customer",
    apply: "Apply",
    clear: "Clear",
    savedViews: "Saved views",
    today: "Today",
    last7: "Last 7 days",
    last30: "Last 30 days",
    thisMonth: "This month",
    custom: "Custom",
    from: "From",
    to: "To",
  },
  tabs: {
    all: "All",
    overdue: "Overdue",
  },
  type: {
    e_arsiv: "e-Arsiv",
    e_fatura: "e-Fatura",
  },
  status: {
    draft: "Draft",
    issued: "Issued",
    sent: "Sent",
    paid: "Paid",
    voided: "Voided",
    failed: "Failed",
  },
  delivery: {
    not_sent: "Not sent",
    sent_email: "Email",
    sent_whatsapp: "WhatsApp",
    delivered: "Delivered",
    opened: "Opened",
  },
  columns: {
    invoiceNumber: "Invoice No",
    issuedAt: "Date",
    customer: "Customer",
    type: "Type",
    total: "Total",
    paid: "Paid",
    balance: "Balance",
    status: "Status",
    delivery: "Delivery",
    actions: "Actions",
  },
  row: {
    draftBadge: "Draft",
    overdue: "Overdue",
    dueIn: "left",
    failedRetry: "Retry",
    viewDetail: "View detail",
    pdf: "Download PDF",
    xml: "Download UBL-XML",
    copyShareLink: "Copy pay link",
    sendEmail: "Send via email",
    sendWhatsapp: "Send via WhatsApp",
    issue: "Issue invoice",
    void: "Void",
    selectRow: "Select row",
    selectAll: "Select all",
    rowActions: "Row actions",
  },
  detail: {
    title: "Invoice Detail",
    lines: "Line items",
    payments: "Payments",
    notes: "Notes",
    issuedBy: "Issued at",
    gibCode: "GIB code",
    integrator: "Integrator",
    integratorError: "Integrator error",
    linkedOrder: "Linked order",
    linkedBooking: "Linked booking",
    copy: "Copy",
    retryIssue: "Retry",
    download: "Download",
    customer: "Customer",
    summary: "Summary",
    subtotal: "Subtotal",
    discount: "Discount",
    tax: "Tax",
    total: "Total",
    paid: "Paid",
    balance: "Balance",
    audit: "Audit",
    createdAt: "Created",
    updatedAt: "Updated",
    close: "Close",
    print: "Print",
  },
  voidDialog: {
    title: "Void Invoice",
    description:
      "This action cannot be undone. You may need to issue a corrective invoice.",
    reason: "Reason",
    cancel: "Cancel",
    confirm: "Void invoice",
    reasons: {
      wrong_customer: "Wrong customer",
      wrong_amount: "Wrong amount",
      wrong_service: "Wrong service",
      customer_request: "Customer request",
      other: "Other",
    },
    explanationLabel: "Explanation",
    explanationPlaceholder: "Please add at least 10 characters",
  },
  sendDialog: {
    title: "Send Invoice",
    email: "Email",
    whatsapp: "WhatsApp",
    target: "Recipient",
    emailPlaceholder: "name@example.com",
    phonePlaceholder: "+90 555 000 0000",
    cancel: "Cancel",
    send: "Send",
    messageLabel: "Note (optional)",
    messagePlaceholder: "Short note for the customer…",
  },
  bulk: {
    selected: "invoices selected",
    sendAll: "Send all",
    downloadZip: "Download PDFs (Zip)",
    voidAll: "Void all",
    clear: "Clear selection",
  },
  empty: {
    title: "No invoices yet",
    description:
      "Once you complete a cashier transaction, invoices will appear here automatically.",
    createAction: "Create invoice",
  },
  errors: {
    loadFailed: "Could not load invoices",
    issueFailed: "Could not issue invoice",
    sendFailed: "Could not send invoice",
    voidFailed: "Could not void invoice",
    downloadFailed: "Could not download invoice",
    retry: "Retry",
    integratorOffline: "GIB integrator offline",
  },
  toasts: {
    issued: "Invoice issued",
    sent: "Invoice sent",
    voided: "Invoice voided",
    downloaded: "Invoice downloaded",
    linkCopied: "Pay link copied",
  },
  pagination: {
    pageOf: "Page",
    records: "records",
    prev: "Previous",
    next: "Next",
  },
};
